import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { BoardTemplatesModalContext } from "./BoardTemplatesModalContext";

export const useBoardTemplatesModalProvider = () => {
  const context = useContext(BoardTemplatesModalContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useBoardTemplatesModalProvider",
      "BoardTemplatesModalContext"
    );
  }

  return context;
};
